import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OptionsInterface } from '../options.interface';

@Component({
    selector: 'nm-cascade-menu',
    templateUrl: './cascade-menu.component.html',
    styleUrls: ['./cascade-menu.component.scss']
})
export class NmCascadeMenuComponent {

    @Input() menuVisible: boolean;
    @Input() steps: Array<Array<OptionsInterface>>;

    @Output() selectChange: EventEmitter<{step: number, index: number}>;

    constructor() {
        this.selectChange = new EventEmitter<{step: number, index: number}>();
    }

    selectHandle(event: Event, step: number, index: number): void {
        event.stopPropagation();
        this.selectChange.emit({step, index});
    }

    clickHandle(event: Event) {
        event.stopPropagation();
    }

}
